// extracted by mini-css-extract-plugin
export default {"details":"DeletePostWarning_details__3k3fg","wrapper":"DeletePostWarning_wrapper__ZwdmA"};